const RequestStatus = {
	LOADING: "LOADING",
	FULFILLED: "FULFILLED",
	ERROR: "ERROR",
};

export { RequestStatus };
